import React from "react";
import "./error-message-label.scss";

const errorMessage = props => {
  let opacity = props.show ? "1" : "0";
  return (
    <span tabIndex="0" aria-live="assertive" role="alert" aria-atomic="true" className={"error-label "+(props.className || '')} style={{ opacity: opacity }} {...props}>
      {props.label}
    </span>
  );
};
export default errorMessage;
